import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {Link} from 'react-router-dom';
import {get} from 'lodash';
import classnames from 'classnames';
import i18n from 'i18n';

import AutoHideHeader from 'modules/shared/components/AutoHideHeader/AutoHideHeader';
import {PowerByVoxfeed, Img} from 'apps/shared/components';
import {UserAvatarDropdown, OrganizationMenu} from 'apps/advertisers/Header/controllers';

import styles from './Menubar.less';
import { logoImg } from 'assets/images';
import { openChat } from 'utils/crispActions';


const ADVERTISERS_HELP_URL = 'https://support.voxfeed.com/hc/es';
const HEADER_HEIGHT = 56;

const Menubar = createClass({
  propTypes: {
    user: PropTypes.object,
    logout: PropTypes.func,
    inspectorComponent: PropTypes.any,
    header: PropTypes.object,
    onBrandSearcherChange: PropTypes.func,
    offset: PropTypes.number
  },

  getInitialState() {
    return {isBrandSearcherActive: false};
  },

  getHeaderStyle() {
    const color = get(this.props, 'header.color');

    if (color) return {background: `linear-gradient(180deg, #272727 0%, ${color} 100%)`};
    return {};
  },

  render() {
    const {
      user,
      logout,
      inspectorComponent,
      header,
      offset,
      partnerSettings,
      ...other
    } = this.props;

    const headerComponent = get(header, 'component');
    const hasImage = !!get(header, 'image');
    const className = classnames('flex between-xs', styles.menu);
    const logoImage = get(partnerSettings, 'ui.logo', logoImg);

    return (
      <div>
        <AutoHideHeader
          offset={offset}
          anchor={header ? HEADER_HEIGHT : 0}
          {...other}
        >
          {hasImage &&
            <Img
              className='image-cover image-fit-parent'
              src={get(header, 'image')}
              sizes='100vw'
            />
          }

          {inspectorComponent}

          <div className={classnames({'vf-bg-secondary-color': !hasImage})} style={this.getHeaderStyle()}>
            {hasImage && <div className={styles.overlay} /> }
            <div className={className}>
              <div className='flex height100'>
                <Link
                  to='/brands'
                  className='height100 margin-right-3x vf-clickable'
                  style={{padding: '1.5rem 0'}}
                >
                  <img alt='presentation' src={logoImage} className='height100' />
                </Link>

                <Options />
              </div>

              <div className='flex height100'>
                <OrganizationMenu />

                {partnerSettings && <PowerByVoxfeed style={{width: '150px', transform: 'scale(0.8)'}} />}
                  <a
                    onClick = {openChat}
                    className={`vf-badge margin-right-1x ${styles['intercom-launcher']}`}
                    title={i18n.get('INTERCOM_LAUNCHER')}
                    data-tour-adv-landing= '5'
                  >
                    <i
                      className='vf-icon icon-intercom vf-font-bold vf-text-white'
                      style={{fontSize: '1.5rem', lineHeight: '1.5rem'}}
                    />
                  </a>
                <a
                  href={ADVERTISERS_HELP_URL}
                  className={`vf-badge margin-right-1x ${styles.help}`}
                  target='_blank'
                  title={i18n.get('ADV_BRANDS_HEADER_HELP_CENTER')}
                  data-tour-adv-landing='3'
                >
                  <span className='vf-text-secondary vf-font-bold'>?</span>
                </a>

                <span data-tour-adv-landing='4'>
                  <UserAvatarDropdown 
                    logout = {logout}
                  />
                </span>

              </div>
            </div>

            {headerComponent && (
              <div className={styles.header}>
                {headerComponent}
              </div>
            )}
          </div>
        </AutoHideHeader>
      </div>
    );
  }
});

const Options = createClass({
  propTypes: {
    onShowSearcher: PropTypes.func
  },

  render() {
    return (
      <div className='flex height100'>
        <Option
          data-uitest='my-brands-tab'
          title={i18n.get('ADV_BRANDS_HEADER_BRANDS')}
          icon='ic-brands-menu'
          className='margin-right-2x'
          redirectTo='/brands'
          isActive={/^\/brands/.test(window.location.pathname)}
          data-tour-adv-landing='1'
        />

        <Option
          title={i18n.get('ADV_BRANDS_HEADER_INFLUENCERS')}
          icon='influencers'
          redirectTo='/influencers/social-networks'
          className='margin-right-2x'
          isActive={/^\/influencers\/social-networks/.test(window.location.pathname)}
          data-tour-adv-landing='2'
        />
      </div>
    );
  }
});

const Option = ({title, redirectTo, icon, className, isActive, ...other}) => (
  <Link
    to={redirectTo}
    className={`flex center-xs ${styles.option} ${className} ${isActive ? styles.active : ''}`}
    {...other}
  >
    <i
      className={`vf-icon icon-${icon} margin-right-1x`}
      style={{fontSize: '2.25rem', lineHeight: '2.25rem'}}
    />
    <span>{title}</span>
  </Link>
);

Option.propTypes = {
  title: PropTypes.string,
  redirectTo: PropTypes.string,
  icon: PropTypes.string,
  isActive: PropTypes.bool,
  className: PropTypes.string
};

const UserMenuOptions = () => (
  <ul className='vf-clear-ul'>
    <li className={`flex start-xs padding-horizontal-1x ${styles['user-menu-option']}`}>
      <Link to='/settings/account' className={styles.link}>
        <i className={`vf-icon icon-user ${styles.icon}`} />
        {' '}
        {i18n.get('ADV_BRANDS_HEADER_ACCOUNT')}
      </Link>
    </li>

    <li className={`flex start-xs padding-horizontal-1x ${styles['user-menu-option']}`}>
      <Link to='/settings/about' className={styles.link}>
        <i className={`vf-icon icon-info ${styles.icon}`} />
        {' '}
        {i18n.get('ADV_BRANDS_HEADER_ABOUT')}
      </Link>
    </li>
  </ul>
);

export default Menubar;
